<template>
  <div >
    <vs-popup
      
      :title="$t('ItemCode')"
      :active.sync="showModal"
      id="item-popup"
    >

    <div class="vx-card mt-5">
      <div class="vx-card__body card-body">

        <div class="vx-row mt-5">
          <div
            class="vx-col w-full mb-base"
            v-if="model.purchaseItems && model.purchaseItems.length > 0"
          >
            <vs-table
              :data="model.purchaseItems"
              class="custom-tbl"
              id="colored-table"
            >
              <template slot="thead">
                <th style="width: 20%">{{ $t("ProductName") }}</th>
                <th style="width: 10%">{{ $t("ModelNumber") }}</th>
                <th style="width: 10%">{{ $t("ItemCode") }}</th>

              </template>

              <template slot-scope="{ data }">
                <vs-tr v-for="(row, index) in data" :key="index">
                  <vs-td>
                    {{ row.purchaseInvoiceProductInfo.name }}
                  </vs-td>
                  <vs-td>
                    {{ row.purchaseInvoiceProductInfo.modelNumber }}
                  </vs-td>
                  <vs-td>
                    <vs-input
                      v-model="row.purchaseInvoiceProductInfo.itemCode"
                      name="name"
                    />
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div class="flex justify-end w-full ml-5">
            <vs-button
              type="filled"
              v-has-permission="'UpdateItemCodeOfInvoiceItems'"
              @click.prevent="saveItemCode"
            >
              <span> {{ $t("SaveItemCode") }}</span>
            </vs-button>
          </div>

        </div>

      </div>
    </div>
    </vs-popup>
  </div>
</template>
<style lang="scss">
#item-popup .vs-popup--content {
  overflow-y: scroll !important;
}
#item-popup  .vs-popup {
  width: 1200px !important;
}
</style>
<script>
import { mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
export default {
  props: {
    show: { default: false },
    model: { default: {} }
  },
  data() {
    return {
      gridSearchData: {},

    };
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  components: {
    DataGrid
  },
  methods: {
    ...mapActions({
      saveItemCodeFunction: "purchaseInvoice/saveItemCodeFunction",

    }),
    saveItemCode() {
      var InvoiceItems = [];
      this.model.purchaseItems.forEach((element) => {
        var x = {
          modelNumber: element.purchaseInvoiceProductInfo.modelNumber,
          count: element.count,
          itemCode: element.purchaseInvoiceProductInfo.itemCode,
        };
        InvoiceItems.push(x);
      });
      const payload = {
        purchaseInvoiceId: this.model.id,
        purchaseInvoiceItems: InvoiceItems,
      };
      this.saveItemCodeFunction(payload).then((r) => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "کد کالا مورد نظر ویرایش شد",
          showConfirmButton: false,
          timer: 2000,
        })
          .then(() => {
            this.load();
            this.$emit("finish");
                    })
          .catch(() => {
            console.log("error");
            this.$emit("finish");
          });
      });
    },
  }
};
</script>
